import React, { ReactElement } from 'react';
import { StyleSheet } from 'react-native';

import LightningBoltIcon from '@/assets/icons/lightning-bolt';
import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { withOpacity } from '@/styles/styles';

const styles = StyleSheet.create({
    container: {
        backgroundColor: withOpacity(ds.colorValue.background.accent.amber.strong, 0.15),
    },
});

type FirstTimePurchaseBannerProps = {
    isVisible?: boolean;
    message?: string;
};

export const FirstTimePurchaseBanner = ({
    isVisible = true,
    message = 'First time purchase boost applied',
}: FirstTimePurchaseBannerProps): ReactElement | null => {
    if (!isVisible) {
        return null;
    }

    return (
        <Row
            px={'s16'}
            py={'s8'}
            borderRadius={'r10'}
            alignItems={'center'}
            justifyContent={'center'}
            height={36}
            style={styles.container}
        >
            <LightningBoltIcon color={ds.colorValue.icon.accent.amber} size={16} />
            <Text variant="labelLarge" color={ds.colorToken.text.accent.amber} ml={'s8'}>
                {message}
            </Text>
        </Row>
    );
};
